import script from "./CategoryList.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryList.vue?vue&type=script&setup=true&lang=js"

import "./CategoryList.vue?vue&type=style&index=0&id=2389559e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2389559e"]])

export default __exports__